// Dependencias
import axios from 'axios';

// Utils
import { httpTokenInterceptor } from '../utils/httpTokenInterceptor';

// KEYS y Confgiuraciones
import { URL_API } from '../config/keys.config';
const token = document.querySelector<HTMLInputElement>('#access-token')!.value;

// Instancia de cliente de Axios
const axiosClient = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

axiosClient.interceptors.response.use((res) => res, httpTokenInterceptor);

/**
 * 
 * @param idclient 
 * @returns 
 */
export async function getClientDetails(idclient: number) {
  const { data } = await axiosClient.get<HttpResponse<ClientWHMCS>>(`/panel/getClient/${idclient}`);
  
  return data;
}

// Definición de tipos e interfaces
export type HttpResponse<T> = {
  status: number;
  respose: boolean;
  message: string;
  client?: T;
}
export type ClientWHMCS = {
  idclient: number;
  nombre: string;
  apellidos: string;
  telefono: string;
  email: string;
};